import i18n from '../../shared/i18n/i18n';

const UnitTypes = {
    scorm: {
        label: "Interactive",
        icon: "icon-grid"
    },
    form: {
        label: "form",
        icon: "icon-document-edit"
    },
    assessment: {
        label: "assessment",
        icon: "icon-certificate-1"
    },
    event: {
        label: "face_to_face",
        icon: "icon-user-pair"
    },
    document: {
        label: "document",
        icon: "icon-document"
    },
    certificate: {
        label: "certificate",
        icon: "icon-certificate-2"
    },
    action: {
        label: "action",
        icon: "icon-star"
    },
    approval: {
        label: "approval",
        icon: "icon-checkbox-checked"
    },
    download: {
        label: "download",
        icon: "icon-download"
    },
    upload: {
        label: "upload",
        icon: "icon-download rotate-180"
    }
};

const normalizeType = (type) => {
    if (!type) return "";
    return typeof type === "string" ? type.toLowerCase() : "";
};

const UnitUtilities = {
    unitTypes: Object.fromEntries(
        Object.entries(UnitTypes).map(([key, value]) => [key, i18n.t(value.label)])
    ),

    getUnitTypeIcon: (type) => {
        const key = normalizeType(type);
        return UnitTypes[key]?.icon || "";
    },

    getUnitTypeName: (type) => {
        const key = normalizeType(type);
        const labelKey = UnitTypes[key]?.label;
        return labelKey ? i18n.t(labelKey) : "";
    }
};

export default UnitUtilities;
